<template>
  <!-- 订单详情 -->
  <div class="Booking">
    <div class="jindutiao">
      <div class="title">订单状态</div>
      <el-steps v-if="form.status!=4" :active="form.status">
        <el-step
          icon="el-icon-success"
          title="已下单"
          :description="form.create_time"
        ></el-step>
        <el-step
          icon="el-icon-success"
          title="处理中"
        ></el-step>
        <el-step icon="el-icon-success" title="已完成" :description="form.create_time"></el-step>
      </el-steps>
      <div class="quxiaodd" v-if="form.status==4" :active="form.status">
          <el-steps align-center :active="form.status" >
              <el-step icon="el-icon-error" title="用户取消订单" :description="form.four_status_time"></el-step>
          </el-steps>
      </div>
      <!-- <div class="quxiaodd" v-if="form.status==4" :active="form.status">
       <div class="kehu">
        用户取消订单
       </div>
       <i class="el-icon-error"></i>
       <div class="shijian">{{form.create_time}}</div>
      </div> -->
    </div>
    <div class="contenmt">
      <!-- 订单信息 -->
      <div>
        <div class="con-tit">订单信息</div>
        <div class="neirong">
          <div class="nr">
            <div class="nr-t">订单编号</div>
            <div class="nr-c">{{form.order_sn}}</div>
          </div>
          <div class="nr nryi">
            <div class="nr-t">订单类型</div>
            <div class="nr-c">美加到门</div>
          </div>
          <div class="nr nryi">
            <div class="nr-t">下单时间</div>
            <div class="nr-c">{{form.create_time}}</div>
          </div>
        </div>
        <div class="neirong">
          <div class="nr">
            <div class="nr-t">订单金额</div>
            <div class="nr-c">${{form.price}}</div>
          </div>
        </div>
      </div>
      <!-- 基本信息 -->
      <div>
        <div class="con-tit">基本信息</div>
        <div class="neirong">
          <div class="nr">
            <div class="nr-t">下单类型</div>
            <div class="nr-c">{{form.type==1?'出口':'进口'}}</div>
          </div>
          <div class="nr nryi">
            <div class="nr-t">下单国家</div>
            <div class="nr-c">{{form.country_name}}</div>
          </div>
          <div class="nr nryi">
            <div class="nr-t">{{form.type==1?'起运港':'卸货港'}}</div>
            <div class="nr-c">{{form.state_port_name}}</div>
          </div>
        </div>
        <div class="neirong">
          <div class="nr">
            <div class="nr-t">{{form.type==1?'送达城市(邮编)':'起运城市(邮编)'}}</div>
            <div class="nr-c">{{form.end_city_name}}</div>
          </div>
          <div class="nr nryi">
            <div class="nr-t">{{form.type==1?'卸货港/卸货地':'装货港/装货地'}}</div>
            <div class="nr-c">{{form.port_name}}</div>
          </div>
        </div>
        <div class="neirong daInput">
          <div class="nr">
            <div class="nr-t">最终目的地/联系人/电话/联系邮箱：</div>
            <!-- <p class="nr-c nr-csan">{{form.dest_address == ''?'暂无信息':form.dest_address}}</p> -->
            <el-input readonly  type="textarea" v-model="form.dest_address"></el-input>
          </div>
        </div>
      </div>

      <!-- 其他信息 -->
      <div class="con-tit">其他信息</div>
        <!-- 表格 -->
        <el-table
          :data="form.goods"
          style="width: 100%"
          :header-cell-style="{ background: '#f9f9f9' }"
      >
          <el-table-column prop="cases_gauge_type_id" label="箱型"> </el-table-column>
          <el-table-column prop="boxno" label="箱号"> </el-table-column>
          <el-table-column  prop="weight" label="单箱重量（kg）"> </el-table-column>
      </el-table>

      <div>
        <div class="neirong">
          <div class="nr">
            <div class="nr-t">总重量(kgs)</div>
            <div class="nr-c">{{form.total_weight}}</div>
          </div>
        </div>
        <div class="neirong">
          <div class="nr">
            <div class="nr-t">下单联系人</div>
            <div class="nr-c">{{form.order_username}}</div>
          </div>
          <div class="nr nryi">
            <div class="nr-t">联系人电话</div>
            <div class="nr-c">{{form.order_phone}}</div>
          </div>
          <div class="nr nryi">
            <div class="nr-t">联系人邮箱</div>
            <div class="nr-c">{{form.email}}</div>
          </div>
        </div>
        <div class="neirong">
          <div class="nr">
            <div class="nr-t">船东</div>
            <div class="nr-c">{{form.shipowner_id}}</div>
          </div>
          <div class="nr nryi">
            <div class="nr-t">航名/航次</div>
            <div class="nr-c">{{form.vessel_voyage}}</div>
          </div>
          <div class="nr nryi">
            <div class="nr-t">销售代码</div>
            <div class="nr-c">{{form.sales_code}}</div>
          </div>
        </div>
        <div class="neirong">
          <div class="nr">
            <div class="nr-t">提单类型</div>
            <div class="nr-c">{{form.bill_of_lading_type_desc}}</div>
          </div>
          <div class="nr nryi">
            <div class="nr-t">运输模式</div>
            <div class="nr-c">
              {{
                form.transport_mode == 1 ? 
                'DAP':
                (form.transport_mode == 2 ? 'DDU' : 'DDP')
              }}
            </div>
          </div>
          <div class="nr nryi">
            <div class="nr-t">主单提单号</div>
            <div class="nr-c">{{form.mawb_blno}}</div>
          </div>
        </div>
        <div class="neirong">
          <div class="nr">
            <div class="nr-t">分单提单号</div>
            <div class="nr-c">{{form.split_order_blno}}</div>
          </div>
        </div>

        <!-- 订单备注 -->
        <div>
          <div class="neirong">
            <div class="nr daInput">
              <div class="nr-t">分单目的港代理联系人信息</div>
              <!-- <p class="nr-c nr-csan">{{form.split_order_address}}</p> -->
              <el-input readonly  type="textarea" v-model="form.split_order_address"></el-input>
            </div>
          </div>
          <div class="neirong">
            <div class="nr daInput">
              <div class="nr-t">订单备注</div>
              <!-- <p class="nr-c nr-csan">{{form.order_remarks}}</p> -->
              <el-input readonly  type="textarea" v-model="form.order_remarks"></el-input>
            </div>
          </div>
        </div>
      </div>
      <div class="btnss">
        
        <el-button v-if="form.status==1" class="quxiao"  @click="dialogFormVisible = true">取消订单</el-button>
        <!-- <el-button class="yulan">预览</el-button> -->
        <el-button class="daochu" @click="daochu">导出</el-button>
      </div>
    </div>

    <!-- 取消订单原因 -->
    <el-dialog title="订单取消" :visible.sync="dialogFormVisible">
      <el-form :model="cancelForm">
        <el-form-item label="取消原因" >
          <el-input
            type="textarea"
            placeholder="请输入"
            v-model="cancelForm.cancel_reason">
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary"  @click="cancellation">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
    
<script>
import { myOrdersDetail,mjCancelOrder,mjdmCreateOrderInfo } from "@/api/api";
export default {
  components: {},
  props:{
  },
  data() {
    return {
      active: 1,
      headers:{
        token: localStorage.getItem('token')
      },
      form:{},
      dialogFormVisible:false,
      cancelForm:{
        cancel_reason:''
      }
    };
  },
  methods: {
    async getDetails(){
        try {
            const res = await myOrdersDetail({
              id: this.$route.query.id
            },this.headers)
            if(res.code==1){
                this.form = res.data
                if(this.form.dest_address == ''){
                  this.form.dest_address = '暂无信息'
                }
            }
        } catch (error) {
            console.log(error,'失败');
        }
    },
    // 取消订单
    async cancellation(){
      if (this.cancelForm.cancel_reason.trim()==''){
        this.$message({
          type:'error',
          message:'取消原因不能为空'
        })
      }else{
        try {
            const res = await mjCancelOrder({
              id: this.$route.query.id,
              cancel_reason:this.cancelForm.cancel_reason.trim()
            },this.headers)
            if(res.code==1){
                this.$message({
                  type:'success',
                  message:'订单取消成功'
                })
                this.dialogFormVisible = false
                this.form.status=4
            }else{
              this.$message({
                type:'error',
                message:res.message
              })
            }
        } catch (error) {
            console.log(error,'失败');
        }
      }
    },
    async daochu(){
          try {
              const res = await mjdmCreateOrderInfo({
                  id: this.$route.query.id
              },this.headers)
              if(res.code==1){
                  // this.form = res.data
                  this.$message({
                      type:'success',
                      message:'导出成功'
                  })
                  const link = document.createElement('a');
                  link.href = res.data.url;
                  link.setAttribute('download', '');
                  document.body.appendChild(link);
                  link.click();
                  document.body.removeChild(link);
              }else{
                  this.$message({
                      type:'error',
                      message:'导出失败'
                  })
              }
          } catch (error) {
              console.log(error,'失败');
          }
      }
  },
  mounted(){
    this.getDetails()
  }
};
</script>
    
<style style lang="scss" scoped>
.Booking {
  background: pink;
}

.jindutiao {
  width: 1136px;
  height: 180px;
  background: #f9f9f9;
  border-radius: 0px 0px 0px 0px;

  .quxiaodd{
    text-align: center;
    .kehu{
      font-size: 16px;
      color: #999999;
    }
    .shijian{
      font-size: 14px;
      color: #999999;
    }

    .el-icon-error{
      color: #0073F5;
      font-size: 20px;
      margin: 8px 0px;
    }
  }
  .title {
    padding-top: 24px;
    padding-left: 24px;
    padding-bottom: 20px;

    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 18px;
    color: #333333;
    font-style: normal;
    text-transform: none;
  }

  .el-steps {
    padding: 0 60px;
    justify-content: center;
  }
  :deep(.el-steps) {
    .el-step__icon {
      background: #f9f9f9;
    }
  }
}

.daInput{
    :deep(.el-textarea){
        width: 1044px;
        background: #F9F9F9;
        border-radius: 9px 9px 9px 9px;
        .el-textarea__inner {
            width: 1044px;
            height: 200px;
            background: #F9F9F9;
            border: 0;
        }
    }
}

.contenmt {
  background: #fff;
  padding: 20px;

  .con-tit {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 18px;
    color: #333333;
    font-style: normal;
    text-transform: none;

    padding-top: 12px;
    padding-bottom: 24px;
  }

  .neirong {
    display: flex;
    margin-bottom: 20px;
    .nr {
      display: flex;

      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #333333;
      font-style: normal;
      text-transform: none;
    }

    .nryi {
      margin-left: 40px;
    }

    .nr-t {
      width: 85px;
      height: 20px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #606260;
      line-height: 16px;
      text-align: left;
      font-style: normal;
      text-transform: none;

      margin-top: 10px;
    }

    .nr-c {
      width: 260px;
      height: 40px;
      background: #f9f9f9;
      border-radius: 9px 9px 9px 9px;

      padding: 10px 12px;

      box-sizing: border-box;
    }

    .nr-cer {
      height: 120px;
      margin: 0;
      overflow:hidden;
      display: -webkit-box;  
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      text-overflow: ellipsis; 
    }

    .nr-csan {
      width: 1044px;
      height: 200px;
      margin: 0;
    }

    .chakan {
      text-align: center;

      cursor: pointer;

      color: #0073f5;
    }

    .dongjie {
      display: flex;
      align-items: center;
      span {
        display: inline-block;

        width: 48px;
        height: 20px;
        background: #edf6ff;
        border-radius: 4px 4px 4px 4px;

        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 10px;
        color: #0073f5;
        line-height: 20px;
        text-align: center;
        font-style: normal;
        text-transform: none;

        margin-left: 8px;
      }
    }

    .con-up {
      display: flex;
      align-items: center;
      justify-content: space-between;
      div {
        display: flex;
        align-items: center;
      }
      i {
        font-size: 16px;
        color: #00b53c;
        margin-right: 9px;
      }

      .name {
        width: 130px;

        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;

        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 12px;
        color: #333333;
        font-style: normal;
        text-transform: none;
      }

      .el-butnm {
        color: #0073f5;
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 12px;
        font-style: normal;
        text-transform: none;

        height: 18px;
        padding: 0;
      }
    }
  }
}

.el-table{
  margin-bottom: 24px;
}

.btnss {
  text-align: center;
  margin-top: 48px;
  .el-button {
    width: 100px;
    height: 40px;
    border-radius: 8px 8px 8px 8px;
    border: 0;
    font-size: 14px;
  }

  .quxiao {
    background: #f9f9f9;
    color: #999999;
  }

  .yulan {
    color: #0073f5;
    border: 1px solid #0073f5;
    background: #fff;
  }

  .daochu {
    background: #0073f5;
    color: #fff;
  }
}

.table {
  width: 100%;
  border-spacing: 0;

  border-bottom: solid 1px #eee;

  margin-bottom: 20px;
  .theader {
    height: 48px;
    background: #f9f9f9;

    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #999999;
    font-style: normal;
    text-transform: none;
  }
  .tbody {
    height: 68px;
    background: #fff;

    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #333333;
    font-style: normal;
    text-transform: none;
  }
}

:deep(.el-dialog){
  width: 500px;
  .el-textarea{
    textarea{
      height: 100px;
    }
  }
}
</style>